<script>
import IconList from '@img/icons/lucide/list.svg?vue';
import IconContract from '@img/icons/lucide/file-code-2.svg?vue';
import IconToken from '@img/icons/lucide/coins.svg?vue';
import IconHistory from '@img/icons/lucide/history.svg?vue';
import UiTabs from '~/components/UiTabs.vue';
import TabContractSources from '~/components/address/Verifier/Verifier.vue';
import JettonTabHistory from '~/components/jetton/JettonTabHistory.vue';
import TxRoot from '~/components/address/TxRoot.vue';
import JettonTabHolders from './JettonTabHolders.vue';

export default {
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        supply: {
            type: Number,
            default: 0,
        },
        decimals: {
            type: Number,
            default: 0,
        },
        symbol: {
            type: String,
            default: '',
        },
        address: {
            type: String,
            required: true,
        },
        // DYOR only indexes tradable jettons, so pages whose token has no market
        // (LP pools) hide the tab instead of showing an endless skeleton.
        showSwaps: {
            type: Boolean,
            default: true,
        },
        // LP pools call the holders of their token liquidity providers. The tab
        // key stays 'holders' so the #holders links and deep links keep working.
        holdersLabel: {
            type: String,
            default: undefined,
        },
    },

    render(createElement) {
        return createElement(UiTabs, {
            class: 'card card--tabbed jetton-tabs',
            props: {
                tabs: this.tabs,
                changeUrlHash: true,
            },
            scopedSlots: this.$scopedSlots,
        });
    },

    computed: {
        tabs() {
            return [
                this.showSwaps && this.createTab('swaps', this.$t('address.tab_swaps'), IconHistory, JettonTabHistory, {
                    address: this.address,
                }, true),
                this.createTab('events', this.$t('address.tab_transactions'), IconList, TxRoot, {
                    address: this.address,
                }, false),
                this.createTab('holders', this.holdersLabel || this.$t('jetton.top_holders'), IconToken, JettonTabHolders, {
                    address: this.address,
                    decimals: this.decimals,
                    supply: this.supply,
                    symbol: this.symbol,
                }, false),
                this.createTab('source', this.$t('address.tab_contract'), IconContract, TabContractSources, {
                    address: this.address,
                    isActive: true,
                }, false),
            ].filter(Boolean);
        },
    },

    methods: {
        createTab(key, text, icon, component, props, eager = false) {
            return {
                key,
                text,
                icon,
                content: {
                    key: this.address,
                    component,
                    props,
                    eager,
                },
            };
        },
    },
};
</script>

<style lang="scss">
.jetton-tabs .card-tabs {
    padding-right: 8px;
}
</style>
